import {
  uUrls,
  vdsUrls,
  commonUrls,
  VDS_KEY,
  COMMON,
  VERSION,
} from "../../constants/ApiUrls";
import {
  getData,
  postData,
  updateData,
  postVdsData,
  getVdsData,
  updateVdsData,
} from "../../networkManager/NetworkManager";

export const login = (data) => {
  return postData(VDS_KEY + VERSION + uUrls.LOGIN_USER, data);
};
export const vdsLogin = (data) => {
  return postVdsData(VDS_KEY + VERSION + vdsUrls.LOGIN_USER, data);
};
export const logout = () => {
  return getVdsData(VDS_KEY + VERSION + vdsUrls.LOGOUT_USER);
};

export const register = (data) => {
  return postData(VDS_KEY + VERSION + uUrls.REGISTER_USER, data);
};
export const createPassword = (data) => {
  return updateData(VDS_KEY + VERSION + uUrls.CREATE_PASSWORD, data);
};
export const changePassword = (data) => {
  return updateData(VDS_KEY + VERSION + uUrls.CHANGE_PASSWORD, data);
};
export const forgotPassword = (data) => {
  return postVdsData(VDS_KEY + VERSION + uUrls.FORGOT_PASSWORD, data);
};
export const resetPassword = (data) => {
  return updateData(VDS_KEY + VERSION + uUrls.RESET_PASSWORD, data);
};
export const validateToken = (data) => {
  return getData(VDS_KEY + VERSION + uUrls.TOKEN_VALIDATION);
};
export const getUserProfile = (data) => {
  return getData(VDS_KEY + VERSION + uUrls.USER_PROFILE);
};
export const getVdsProfile = (data) => {
  return getVdsData(VDS_KEY + VERSION + vdsUrls.USER_PROFILE);
};
export const getUserDetailProfile = (id) => {
  return getVdsData(VDS_KEY + VERSION + `${vdsUrls.USER_DETAIL}/${id}`);
};
export const updateVdsProfile = (data) => {
  return updateVdsData(VDS_KEY + VERSION + vdsUrls.USER_PROFILE, data);
};
export const codeVerification = (data) => {
  return updateData(VDS_KEY + VERSION + uUrls.PHONE_NUMBER_VERIFICATION, data);
};
export const resetTokenVerfication = (data) => {
  return postData(VDS_KEY + VERSION + uUrls.RESET_TOKEN_VARIFICATION, data);
};
export const changeLanguagePreference = (language) => {
  return updateData(
    VDS_KEY +
      VERSION +
      `${vdsUrls.USER_LANGUAGE_PREFERENCE}?languagepreference=${language}`
  );
};
export const verifyPhoneNumber = (payload) => {
  return postVdsData(
    VDS_KEY + VERSION + `${vdsUrls.USER_NUMBER_VERIFICATION}`,
    payload
  );
};
export const verifyOtp = (payload) => {
  return postVdsData(
    VDS_KEY + VERSION + `${vdsUrls.OTP_VERIFICATION}`,
    payload
  );
};
export const resendOtp = (payload) => {
  return postVdsData(VDS_KEY + VERSION + `${vdsUrls.RESEND_OTP()}`, payload);
};
export const getDocument = (payload) => {
  return getData(
    VDS_KEY + VERSION + `${commonUrls.FILE_STTREAM}?mediaPath=` + payload
  );
};
